// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import CoreEmbeddableSection from './data'

export default function CoreEmbeddableSectionFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/CoreEmbeddableSection">
      <CoreEmbeddableSection {...props}>
        {children}
      </CoreEmbeddableSection>
    </Flow>
  )
}
